import classNames from 'classnames/bind';
import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from './index.module.scss';
import Item from './Item';

import EmptyList from '@/components/ui/EmptyList';
import { MessageContext } from '@/helpers/MessageProvider';
import useLoadRobots from '@/hooks/useLoadRobots';

const cx = classNames.bind(styles);

const RobotList = () => {
  const { subscribeTelemetry } = useContext(MessageContext);
  const robots = useSelector((state) => state.robots);

  // 로봇내역 조회
  useLoadRobots([{ field: 'model.agentType', value: 'MavLink' }], subscribeTelemetry);

  const sortedRobots = useMemo(() => {
    const activeRobots = robots.filter(({ isActive }) => isActive);
    activeRobots.sort((a, b) => a.name.localeCompare(b.name));

    const inactiveRobots = robots.filter(({ isActive }) => !isActive);
    inactiveRobots.sort((a, b) => a.name.localeCompare(b.name));

    return [...activeRobots, ...inactiveRobots];
  }, [robots]);

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Guide Robots</div>
        <div className={cx('total')}>Total {sortedRobots.length}</div>
      </div>
      <div className={cx('body')}>
        {sortedRobots.length === 0 && (
          <div className={cx('empty')}>
            <EmptyList message="No items" />
          </div>
        )}
        {sortedRobots.map((robot, index) => (
          <Item key={index} robot={robot} />
        ))}
      </div>
    </div>
  );
};

export default RobotList;
